import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ContentService } from 'src/app/service/content.service';

@Component({
  selector: 'app-dash-layout',
  template: `
    <ng-container *ngIf="sessionStorageSet">
      <div class="tw-flex  tw-flex-col ">
        <div class="tw-flex  ">
          <div class="tw-w-[18vw] tw-min-w-[200px] tw-hidden md:tw-block ">
            <div class="tw-p-4">
              <ng-container *ngIf="clientData">
                <img
                  *ngIf="
                    clientData.logoContentRequest.hasClientRecord &&
                    clientData.logoContentRequest.absenceOneClient &&
                    clientData.logoContentRequest.dualLogo
                  "
                  src="data:image/JPEG;base64,{{
                    clientData.logoContentRequest.absenceOneLogoImg
                  }}"
                  class="tw-flex tw-justify-center tw-w-full"
                  alt="{{ clientData.logoContentRequest.absenceOneLogoAlt }}"
                  tabindex="0"
                  [attr.aria-label]="
                    clientData.logoContentRequest.absenceOneLogoAlt
                  "
                  role="link"
                  (click)="onLogoClick()"
                  (keydown.enter)="onLogoClick()"
                />
                <img
                  *ngIf="
                    (clientData.logoContentRequest.hasClientRecord &&
                      !clientData.logoContentRequest.absenceOneClient &&
                      clientData.logoContentRequest.dualLogo) ||
                    !clientData.logoContentRequest.hasClientRecord
                  "
                  src="data:image/JPEG;base64,{{
                    clientData.logoContentRequest.sedgwickLogoImg
                  }}"
                  class="tw-flex tw-justify-center tw-w-full"
                  alt="{{ clientData.logoContentRequest.sedgwickLogoAlt }}"
                  tabindex="0"
                  (click)="onLogoClick()"
                  (keydown.enter)="onLogoClick()"
                  role="link"
                  [attr.aria-label]="
                    clientData.logoContentRequest.sedgwickLogoAlt
                  "
                />
              </ng-container>
            </div>
          </div>

          <div class="tw-flex tw-flex-col tw-w-full tw-min-w-0">
            <div
              id="HeaderContainer"
              class="tw-h-[10vh] tw-min-h-[60px] tw-flex-none"
              role="banner"
            >
              <div id="header" class="tw-h-full tw-bg-white">
                <div id="mainMenu" class="tw-h-full tw-bg-white">
                  <app-header [onHeader]="true" class=""></app-header>
                </div>
              </div>
            </div>

            <div
              id="PageContainer"
              class="tw-min-h-[77vh] tw-overflow-x-auto tw-bg-[var(--sed-warm-white-color)] tw-shadow-md"
            >
              <div id="MainContainer" role="main" class="tw-h-[95%]">
                <router-outlet></router-outlet>
              </div>
            </div>

            <div
              class="tw-h-[10vh] tw-min-h-[60px] tw-flex tw-justify-center app-pt2"
            >
              <app-footer></app-footer>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  `,
  styles: [
    `
      .spinner-background {
        background-color: white;
        z-index: 900;
        position: absolute;
        left: 0;
        top: 0;
        height: 100%;
        width: 100%;
        /* IE 8 */
        -ms-filter: 'progid:DXImageTransform.Microsoft.Alpha(Opacity=50)';
        /* IE 5-7 */
        filter: alpha(opacity=50);
        /* Netscape */
        -moz-opacity: 0.5;
        /* Safari 1.x */
        -khtml-opacity: 0.5;
        /* Good browsers */
        opacity: 0.5;
      }
      .tw-min-h-screen {
        min-height: 100vh;
        height: 230px !important;
      }
      .spinner-page-background {
        background-color: black;
        z-index: 1500;
        position: fixed;
        left: 0;
        top: 0;
        height: 100%;
        width: 100%;
        /* IE 8 */
        -ms-filter: 'progid:DXImageTransform.Microsoft.Alpha(Opacity=50)';
        /* IE 5-7 */
        filter: alpha(opacity=50);
        /* Netscape */
        -moz-opacity: 0.5;
        /* Safari 1.x */
        -khtml-opacity: 0.5;
        /* Good browsers */
        opacity: 0.5;
      }
    `,
  ],
})
export class DashLayoutComponent implements OnInit {
  clientData: any;
  vanitypath: string;
  loginImage: any;
  sessionStorageSet: boolean;

  constructor(private contentService: ContentService, private router: Router) {}

  ngOnInit(): void {
    this.vanitypath = this.vanitypath == null ? '' : this.vanitypath;
    this.clientData = JSON.parse(sessionStorage.getItem('clientData'));

    if (this.clientData == null) {
      this.contentService.GetVanityDetails(this.vanitypath).subscribe(
        (data) => {
          sessionStorage.setItem('clientData', JSON.stringify(data));
          this.clientData = JSON.parse(sessionStorage.getItem('clientData'));
          this.loginImage = this.clientData.loginImage;
          this.sessionStorageSet = true;
        },
        (error) => {}
      );
    } else {
      this.sessionStorageSet = true;
    }
  }

  onLogoClick(): void {
    this.router.navigate(['/']);
  }
}
